var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"toast-container"},[_c('div',{staticClass:"toast-content"},[_c('span',{staticClass:"toast-text"},[_vm._v(_vm._s(_vm.message))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }